/**
 * A fatal error that the user cannot recover from.
 */
export class FatalError extends Error {
  constructor(message: string, options: Options = { report: true }) {
    super(message)

    const { report } = options

    this.name = "FatalError"
    this.report = report
  }

  public report: boolean
}

interface Options {
  /**
   * Set to false if the error is an expected/normal part of the app state checks.
   * Leave to the default of true if this error should be reported to our error tracking system.
   */
  report: boolean
}
